import { shouldUseMocks } from './mockApi'
import * as mock from './mockApi/activitiesApi'
import { patientGet, patientPost } from './patientApi'

const BASE = '/api/secure/me/activities'
const CTX = { requirePatientContext: true }

export async function listActive(profile) {
  if (shouldUseMocks()) return mock.listActive(profile)
  const res = await patientGet(BASE, CTX)
  return res?.data || []
}

export async function listToday(profile) {
  if (shouldUseMocks()) return mock.listActive(profile) // mock unifies these
  const res = await patientGet(`${BASE}/today`, CTX)
  return res?.data || []
}

export async function complete(profile, id, body) {
  if (shouldUseMocks()) return mock.complete(profile, id, body)
  const res = await patientPost(`${BASE}/${encodeURIComponent(id)}/complete`, body || {}, CTX)
  return res?.data
}

export async function history(profile, id) {
  if (shouldUseMocks()) return mock.history(profile, id)
  const res = await patientGet(`${BASE}/${encodeURIComponent(id)}/history`, CTX)
  return res?.data || []
}
